import React from 'react';
import { Outlet } from 'react-router-dom';

const DairyFactory: React.FunctionComponent = () => {
  return <Outlet />;
};

export default DairyFactory;
